module.exports = __webpack_public_path__ + "assets/word_annual_agreement_highlight.dc086b4d.svg";